import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset12 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 6.75V12.75H18.75V6.75H0.75ZM12.75 18.75H6.75V0.75H12.75V18.75Z",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset12;
